import { createGlobalStyle } from 'styled-components'
import { ZingTheme } from './types'

export const GlobalTokens = createGlobalStyle<{ theme: ZingTheme }>`
  :root {
    --primary:           ${({ theme }) => theme.colors.primary};
    --primary-light:     ${({ theme }) => theme.colors.primaryLight};
    --primary-dark:      ${({ theme }) => theme.colors.primaryDark};
    --background:        ${({ theme }) => theme.colors.background};
    --text-primary:      ${({ theme }) => theme.colors.textPrimary};
    --text-secondary:    ${({ theme }) => theme.colors.textSecondary};
    --border:            ${({ theme }) => theme.colors.border};
    --blue200:           ${({ theme }) => theme.colors.blue200};
    --grey400:           ${({ theme }) => theme.colors.grey400};
    --grey300:           ${({ theme }) => theme.colors.grey300};
    --error:             ${({ theme }) => theme.colors.error};
    --black:             ${({ theme }) => theme.colors.black};
    --white:             ${({ theme }) => theme.colors.white};
    --grey600:           ${({ theme }) => theme.colors.grey600};
    --grey800:           ${({ theme }) => theme.colors.grey800};
    --purple100:         ${({ theme }) => theme.colors.purple100};
    --risk:         ${({ theme }) => theme.colors.risk};
    --auth-gradient:     ${({ theme }) => theme.colors.authGradient || ''};
    --success:           ${({ theme }) => theme.colors.success || ''};
    --success-light:     ${({ theme }) => theme.colors.successLight || ''};
    --warning:           ${({ theme }) => theme.colors.warning || ''};
    --warning-light:     ${({ theme }) => theme.colors.warningLight || ''};
    --highlight:            ${({ theme }) => theme.colors.highlight || ''};
    --highlight-light:      ${({ theme }) => theme.colors.highlightLight || ''};
    --secondary-h:          ${({ theme }) => theme.colors.secondaryHighlight || ''};
    --orange-dark:          ${({ theme }) => theme.colors.orangeDark || ''};
    --sidebar-background:   ${({ theme }) => theme.colors.sidebarBackground || ''};
    --shadow-smooth:        ${({ theme }) => theme.colors.shadowSmooth || ''};
    --font-body:            ${({ theme }) => theme.fonts.body};
  }

  body {
    font-family: var(--font-body), sans-serif !important;
  }

  * {
    font-family: inherit;
  }
`
